import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { Amount } from '@fcom/dapi';

@Injectable()
@Pipe({
  name: 'finNonZeroAmount',
  pure: true,
  standalone: false,
})
export class NonZeroAmountPipe implements PipeTransform {
  transform(amount: Amount, active = true): Amount | undefined {
    if (active && (!amount?.amount || parseFloat(amount.amount) == 0)) {
      return undefined;
    }

    return amount;
  }
}
